export const name = 're-core-page-user-profile'
export const component = 're-profile'

import {factory} from '../../../../lib/page'

const props = {
  tab: {},
}

const data = {
  // the value from tab prop will be passed to defaultTab prop of the re-profile component
  renameMergeAttrProps: {
    tab: 'defaultTab'
  }
}

export default factory(name, {props, component, data})
